<template>
  <!-- 公用-页尾 -->
  <div class="index-footer">
    <div class="contact-box">
      <div class="contact-zx contact-item">
        <p class="contact-name">包头市知识产权智慧监管公共服务平台</p>
        <!-- <span class="contact-num">建设单位：<a href="http://www.khwanxiang.com/" target="_blank" style="color: #fff;">北京科华万象科技有限公司</a></span> -->
      </div>
      <div class="contact-js contact-item">
        <p class="contact-name"><!-- rel="noreferrer" http://scjg.baotou.gov.cn/ -->
          指导单位：<span class="links" @click="openNewWindowNoreferrer('http://scjg.baotou.gov.cn/')">包头市市场监督管理局</span>
        </p>
        <p class="contact-name">
          建设及运营单位：<a class="links" target="_blank" href="http://www.khwanxiang.com/"
            >北京科华万象科技有限公司</a
          >
        </p>
        <!-- <span class="contact-num"><a href="https://www.wanxiangyun.net/search/index" target="_blank" style="width:245px;"><img style="width:245px;" src="../assets/images/wxy_white.png" alt=""></a></span> -->
      </div>
      <div class="contact-sw contact-item">
        <p class="contact-name">
          技术咨询：<a style="color: #8aa4ff" href="mailto:chenglei@khwanxiang.com"
            >chenglei@khwanxiang.com</a
          >
        </p>
        <p class="contact-name">
          商务合作：<a style="color: #8aa4ff" href="mailto:doulei@khwanxiang.com"
            >doulei@khwanxiang.com</a
          >
        </p>
        <!-- <span class="contact-num" style="margin-left:215px;display: block;">扫码访问移动应用终端 →</span> -->
      </div>
      <div class="contact-sc contact-item">
        <!-- <img src="../assets/images/baoshui_wchart_code.jpg" style="width: 80px;height: 80px;" alt=""> -->
        <span class="contact-num"
          ><a href="https://www.wanxiangyun.net/search/index" target="_blank" style="width: 245px"
            ><img style="width: 245px" src="../assets/images/wxy_white.png" alt="" /></a
        ></span>
      </div>
    </div>
    <div class="footer-footbottom">
      <div class="footbottom-footnum">
        Copyright © 2022 北京科华万象科技有限公司 All Rights Reserved.&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        京ICP备10215711号-8
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  created() {
  },
  methods: {
    // 解决：a标签访问别人网站打不开的解决办法
    // 在新的窗口不带referer打开连接，适用于主流浏览器，Chrome、Firefox、IE等
    isIE() { // 判断是否是IE
      // console.log(window.ActiveXObject)
      if (window.ActiveXObject || "ActiveXObject" in window) {
        return true
      } else {
        return false
      }
    },
    // ie不带referer打开url，url要打开的链接，blankurl指向一个空页面
    ieNorefererOpen(url, blankurl) {
      if (blankurl === undefined) {
        // blankurl = null
        blankurl = "js/wyq/noreferer/Blank.html"
      }
      let win = window.open(blankurl, '_blank')
      let doc = win.document
      doc.clear()
      doc.write('<html><head><meta http-equiv="Refresh" content="0; URL=' + url + '"/></head><body></body></html>')
      doc.close()
    },
    // 在新的窗口不带referer打开链接，a超链接对象，full_link要打开的链接
    openNewWindowNoreferrer(fullLink) {
      let a = document.createElement('a') // 1.先创建一个a标签
      // a.href = url // 2.给a标签的href赋上下载地址
      a.style.display = 'none' // 3.让a标签不显示在视图中
      // document.body.appendChild(a) // 4.将a标签append到文档中
      // a.click() // 5.a标签自点击
      // document.body.removeChild(a) // 6.点击下载后，销毁这个节点
      if (this.isIE()) {
        a.rel = "noreferrer"
        a.target = "_self"
        this.ieNorefererOpen(fullLink)
      } else {
        a.rel = "noreferrer"
        a.target = "_blank"
        a.href = fullLink
      }
      document.body.appendChild(a) // 4.将a标签append到文档中
      a.click() // 5.a标签自点击
      document.body.removeChild(a) // 6.点击下载后，销毁这个节点
    }
  }
}
</script>

<style scoped>
.index-footer {
  /* position: fixed;
    bottom: 0; */
  width: 100%;
  min-width: 1400px;
  background: #424352;
  text-align: left;
  z-index: 10;
}
.contact-box {
  display: flex;
  margin: 0 auto;
  padding: 20px 0;
  width: 1400px;
  clear: both;
  justify-content: space-between;
  box-sizing: border-box;
}
.contact-item {
  display: inline-block;
}
.contact-name {
  font-size: 14px;
  /* font-weight: bold; */
  /* margin-bottom: 18px; */
  color: #fff;
}
.contact-num {
  font-size: 14px;
  font-weight: 200;
  color: #fff;
}
.footer-footbottom {
  width: 100%;
  height: 30px;
  line-height: 30px;
  background: #000;
  box-sizing: border-box;
  text-align: center;
}
.footbottom-footnum {
  color: #999999;
}
.footnum-footspan {
  color: #999999;
}
.links {
  color: #fff;
  cursor: pointer;
}
</style>
